import { ICellRendererParams } from "ag-grid-community";
import { ReactComponent as BuyBoxIcon } from "@images/buybox_icon.svg";
import { useSelector } from "react-redux";
import { TFocusedAsins } from "@/ts/common-types";

interface IProductActionCellRenderer extends ICellRendererParams {
    hasPinnedColumnValue: boolean;
}

const ProductActionCellRenderer: React.FC<IProductActionCellRenderer> = (
    params
) => {

    const focusedAsins = useSelector(
        (state: TFocusedAsins) => state.focusedAsins.value
    );

    const isFocusedAsin = focusedAsins?.includes(params.data.asin);

    return (
        <div>
            {!params.hasPinnedColumnValue && params.node.rowPinned ? null : (
                <label
                    className="rounded-circle"
                    style={{
                        backgroundColor: `${
                            isFocusedAsin ? "#DEEBFF" : "#F1F6F5"
                        }`,
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "4px",
                        justifyContent: "center",
                    }}
                >
                    <BuyBoxIcon
                        id={`buy-box-${params.data.asin}`}
                        width="25"
                        height="25"
                        stroke={`${
                            isFocusedAsin ? "#0275D8" : "#9FA6B2"
                        }`}
                    />
                </label>
            )}
        </div>
    );
};

export default ProductActionCellRenderer;
